<template>
  <div class="otimepicker">
    <div class="otimepicker-header">
      <span>Saat</span>
      <span>Dakika</span>
    </div>
    <div class="otimepicker-columns">
      <div class="otimepicker-col">
        <div v-for="hour in hours" :key="hour" :class="['otimepicker-item', { selected: hour === selectedHour }]" @click="selectHour(hour)">
          {{ hour.toString().padStart(2, '0') }}
        </div>
      </div>
      <div class="otimepicker-col">
        <div
          v-for="minute in minutes"
          :key="minute"
          :class="['otimepicker-item', { selected: minute === selectedMinute }]"
          @click="selectMinute(minute)"
        >
          {{ minute.toString().padStart(2, '0') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
dayjs.locale('tr');

export default defineComponent({
  name: 'OTimePicker',
  props: {
    time: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    // hours and minutes
    const hours = Array.from({ length: 24 }, (_, i) => i);
    const minutes = Array.from({ length: 60 }, (_, i) => i);

    // selected hour and minute
    const initial = props.time ? dayjs(props.time) : dayjs().hour(0).minute(0);
    const selectedHour = ref(initial.hour());
    const selectedMinute = ref(initial.minute());

    // select hour and minute
    const selectHour = (hour) => {
      selectedHour.value = hour;
      // emitValue();
    };
    const selectMinute = (minute) => {
      selectedMinute.value = minute;
      emitValue();
    };

    // update v-model
    const emitValue = () => {
      const time = dayjs().hour(selectedHour.value).minute(selectedMinute.value).second(0).millisecond(0);
      emit('update:time', time.toDate());
      emit('select', time);
    };

    // update v-model when modelValue changes from outside
    watch(
      () => props.time,
      (val) => {
        if (val) {
          const d = dayjs(val);
          selectedHour.value = d.hour();
          selectedMinute.value = d.minute();
        }
      }
    );

    return {
      hours,
      minutes,
      selectedHour,
      selectedMinute,
      selectHour,
      selectMinute,
    };
  },
});
</script>

<style scoped lang="scss">
.otimepicker {
  background: #000;
  margin: 0 auto;
  width: 152px;
  padding: 24px;
  padding-bottom: 12px;
}
.otimepicker-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.otimepicker-columns {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}
.otimepicker-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-height: 270px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
.otimepicker-item {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #424242;
  font-size: 14px;
  font-weight: 500;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.otimepicker-item.selected {
  background: #6842ef;
  color: #fff;
}
.otimepicker-item:hover:not(.selected) {
  background: #232324;
  color: #fff;
}
</style>
